import React, { useRef } from "react";
import * as Select from "@radix-ui/react-select";
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from "@radix-ui/react-icons";
import classnames from "classnames";

const RadixSelect = ({
  groups,
  onValueChange,
  value,
  className = "",
  triggerClassName = "",
  selectContentClassName = "",
  selectContentWrapperClassName = "",
  placeholder = "Select Country",
  side = "top"
}) => {
  const renderSelectGroups = () => {
    let alphabeticalGroups = groups.flatMap(group => {
      return group.items;
    });
    alphabeticalGroups = alphabeticalGroups.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });
    return alphabeticalGroups.map(item => {
      return (
        <SelectItem key={item.value} value={item.value}>
          {item.label}
        </SelectItem>
      );
    });
  };

  return (
    <Select.Root className={`SelectRoot ${className} `} onValueChange={onValueChange} value={value}>
      <Select.Trigger className={`SelectTrigger ${triggerClassName}`}>
        <Select.Value>{placeholder}</Select.Value>
        <Select.Icon className="SelectIcon">
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content position="popper" side={side} className={`SelectContent ${selectContentWrapperClassName}`}>
          <Select.ScrollUpButton className="SelectScrollButton">
            <ChevronUpIcon />
          </Select.ScrollUpButton>
          <Select.Viewport className={`SelectViewport ${selectContentClassName}`}>{renderSelectGroups()}</Select.Viewport>
          <Select.ScrollDownButton className="SelectScrollButton">
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

const SelectItem = React.forwardRef(({ children, className, ...props }, forwardedRef) => {
  return (
    <Select.Item className={classnames("SelectItem", className)} {...props} ref={forwardedRef}>
      <Select.ItemText>{children}</Select.ItemText>
    </Select.Item>
  );
});

export default RadixSelect;
